import { Link } from "react-router-dom"

function HomeOverview() {


    return (
        <section className="homepage-section homepage-section-overview">
            <h2 className="section-subheading homepage-section-overview__subheading">Star: Kyle Veloso's Sun (Yellow Dwarf)</h2>
            <div className="sun-art-container">
                <div className="sun-art sun-art-overview">
                    <div className="sun-art__surface-container"></div>
                </div>
            </div>
            <h1 className="greeting">Hi! I'm <span className="emp-text">Kyle.</span> A Junior Developer just swinging around!</h1>
            <p className="overview-text homepage-section__overview-text">Welcome to my star system! Currently learning TypeScript. Click on the button below to see my work, or you can navigate through the site by clicking on one of the planets.</p>
            <Link to="/projects" className="link-button">View projects</Link>
         </section>
    )
}

export { HomeOverview }